<template>
  <transition :name="transitionName">
    <div v-show="model" :class="classes">
      <div :class="mainClasses">
        <t-icon icon="loading"></t-icon>
        <div v-if="tip || $slots.default" :class="contentClass">
          <slot>{{ tip }}</slot>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import { PREFIX_CLASS } from '@/utils/constants'
import TIcon from '@/module/icon'
import locale from '@/mixins/locale'
import { removeClass, addClass } from '@/utils/helper'
const PREFIXCLS = `${PREFIX_CLASS}loading`

export default {
  // eslint-disable-next-line
  name: 'loading',
  components: {
    TIcon
  },
  mixins: [ locale ],
  props: {
    transitionName: {
      type: String,
      default: 'fade'
    },
    value: {
      type: Boolean,
      default: false
    },
    size: {
      type: String,
      default: 'md',
      validator(value) {
        return ['sm', 'lg', 'md'].includes(value)
      }
    },
    fullscreen: {
      type: Boolean,
      default: false
    },
    tip: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      prefixCls: PREFIXCLS,
      model: false
    }
  },
  computed: {
    classes () {
      return [
        `${this.prefixCls}`,
        {
          [`${this.prefixCls}--${this.size}`]: !!this.size,
          [`${this.prefixCls}--fix`]: this.fullscreen
        }
      ]
    },
    mainClasses () {
      return `${this.prefixCls}__main`
    },
    contentClass () {
      return `${this.prefixCls}__tip`
    }
  },
  watch: {
    model (val) {
      let parentNode = document.body
      if (val) {
        if (parentNode.originalPosition !== 'absolute' && parentNode.originalPosition !== 'fixed') {
          addClass(parentNode, `${this.prefixCls}__relative`)
        }
      } else {
        if (parentNode.originalPosition !== 'absolute' && parentNode.originalPosition !== 'fixed') {
          removeClass(parentNode, `${this.prefixCls}__relative`)
        }
      }
    }
  },
  mounted() {
    this.model = this.value
  },
  methods: {
    show () {
      this.model = true
    },
    hide () {
      this.model = false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/module/loading/loading.vue